import { DeleteGroupModalComponent } from './DeleteGroupModal.types';
import { Flexbox, Modal, Typography } from '@hiiretail/synergy-ui';
import { StyledButton } from './DeleteGroupModal.styles';

export const DeleteGroupModal: DeleteGroupModalComponent = ({
  groupName,
  open,
  onClose,
  isDeleting,
  deleteGroup,
}) => {
  return (
    <Modal
      data-testid="delete-group-modal"
      title={groupName}
      open={open}
      onClose={onClose}
      footer={
        <Flexbox container justifyContent="flex-end">
          <StyledButton
            disabled={isDeleting}
            onClick={onClose}
            variant="secondary"
          >
            No
          </StyledButton>
          <StyledButton
            disabled={isDeleting}
            onClick={deleteGroup}
            type="submit"
          >
            Yes
          </StyledButton>
        </Flexbox>
      }
    >
      <Flexbox container item>
        <Typography>You are about to delete a group, this operation can not be undone.</Typography>
      </Flexbox>
      <Flexbox container item>
        <Typography>Are you sure you want to proceed?</Typography>
      </Flexbox>
    </Modal>
  );
}
